import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from 'src/app/providers/services/auth.service';
import {CONSTANTS} from 'src/app/constants';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private auth: AuthService,
        private router: Router
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const auth = await this.auth.isAuthenticated();
        if (!auth) {
            this.router.navigate([CONSTANTS.ROUTES.LOGIN],{ queryParams: { returnUrl: state.url }});
        }

        return !!auth;
    }
}
